export interface GameCategory {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: GameCategory[] = [
  {
    slug: 'rpg',
    name: 'RPG角色扮演',
    description: '沉浸式剧情体验，在奇幻世界中展开冒险旅程',
    icon: 'ri-sword-line',
    count: 128,
  },
  {
    slug: 'slg',
    name: 'SLG策略模拟',
    description: '运筹帷幄之中，决胜千里之外',
    icon: 'ri-mind-map',
    count: 96,
  },
  {
    slug: 'avg',
    name: 'AVG文字冒险',
    description: '沉浸式视觉小说，感受动人的故事与情感',
    icon: 'ri-book-open-line',
    count: 215,
  },
  {
    slug: 'act',
    name: 'ACT动作游戏',
    description: '流畅的操作手感，爽快的战斗体验',
    icon: 'ri-gamepad-line',
    count: 87,
  },
  {
    slug: 'simulation',
    name: '模拟经营',
    description: '打造属于你的世界，经营属于你的事业',
    icon: 'ri-building-2-line',
    count: 64,
  },
  {
    slug: 'indie',
    name: '独立游戏',
    description: '创意无限的独立作品，独特的美术与玩法',
    icon: 'ri-lightbulb-line',
    count: 153,
  },
];

export interface Game {
  slug: string;
  title: string;
  category: string;
  rating: number;
  imageUrl: string;
  thumbUrl: string;
  description: string;
  tags: string[];
  releaseDate: string;
  platform: string[];
  developer: string;
}

export const games: Game[] = [
  {
    slug: 'star-ocean-fantasy',
    title: '星海幻境',
    category: 'rpg',
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautifully%20illustrated%20fantasy%20RPG%20game%20cover%20featuring%20a%20starlit%20ocean%20with%20magical%20glowing%20waves%2C%20a%20lone%20heroine%20standing%20on%20a%20cliff%20edge%2C%20vibrant%20nebula%20sky%2C%20anime%20art%20style%2C%20rich%20purple%20and%20gold%20color%20palette%2C%20soft%20ethereal%20lighting%2C%20game%20poster%20style&width=800&height=400&seq=game-star-ocean&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=A%20beautifully%20illustrated%20fantasy%20RPG%20game%20cover%20featuring%20a%20starlit%20ocean%20with%20magical%20glowing%20waves%2C%20a%20lone%20heroine%20standing%20on%20a%20cliff%20edge%2C%20vibrant%20nebula%20sky%2C%20anime%20art%20style&width=120&height=80&seq=game-star-ocean-thumb&orientation=landscape',
    description: '一款融合了太空歌剧与古典奇幻元素的史诗级RPG作品。玩家将扮演一位星际探险家，在浩瀚宇宙中探索未知星球，揭开古老的文明秘密。游戏拥有超过100小时的丰富剧情，多线结局系统让每次游玩都有全新体验。精致的角色立绘、动人的配乐以及深度的战斗系统，让这款作品成为年度必玩的黄油RPG佳作。',
    tags: ['剧情丰富', '多结局', '精美立绘', '开放世界'],
    releaseDate: '2025-03-15',
    platform: ['PC', 'Switch'],
    developer: '星海工作室',
  },
  {
    slug: 'kingdom-conquest',
    title: '王国征途',
    category: 'slg',
    rating: 9.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20strategy%20game%20cover%20art%20showing%20a%20medieval%20fantasy%20kingdom%20with%20towering%20castles%2C%20armies%20marching%20across%20golden%20fields%20at%20sunset%2C%20dramatic%20sky%20with%20crimson%20clouds%2C%20detailed%20soldiers%20and%20banners%2C%20grand%20scale%20illustration%2C%20warm%20amber%20and%20gold%20tones&width=800&height=400&seq=game-kingdom&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Epic%20strategy%20game%20cover%20art%20showing%20a%20medieval%20fantasy%20kingdom%20with%20towering%20castles%2C%20armies%20marching%20across%20golden%20fields%20at%20sunset&width=120&height=80&seq=game-kingdom-thumb&orientation=landscape',
    description: '一款宏大的策略模拟游戏，玩家将扮演一位领主，建设自己的王国并与其他势力展开激烈的领土争夺。游戏融合了城市建设、资源管理、外交策略与战斗指挥等多种玩法元素。精美的角色互动系统、丰富的剧情事件链以及深度的策略博弈，让每一局都充满了变数与挑战。',
    tags: ['策略深度', '领土争夺', '角色互动', '城市建设'],
    releaseDate: '2025-01-20',
    platform: ['PC', 'Android'],
    developer: '帝国工作室',
  },
  {
    slug: 'sakura-memories',
    title: '樱花回忆',
    category: 'avg',
    rating: 9.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20visual%20novel%20game%20cover%20with%20falling%20cherry%20blossom%20petals%20in%20soft%20pink%20tones%2C%20a%20Japanese%20high%20school%20setting%20in%20spring%2C%20two%20characters%20standing%20under%20a%20sakura%20tree%20at%20golden%20hour%2C%20gentle%20warm%20lighting%2C%20anime%20illustration%20style&width=800&height=400&seq=game-sakura&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Romantic%20visual%20novel%20game%20cover%20with%20falling%20cherry%20blossom%20petals%20in%20soft%20pink%20tones%2C%20Japanese%20high%20school%20in%20spring&width=120&height=80&seq=game-sakura-thumb&orientation=landscape',
    description: '感动百万玩家的纯爱视觉小说，讲述了一段跨越时空的樱花之恋。游戏以日本小镇为舞台，通过细腻的文字描写与精美的手绘CG，将青春、爱情、友情与成长的故事娓娓道来。全语音配音阵容豪华，多条感情线让玩家可以体验不同的故事结局。被誉为近年来最令人感动的黄油AVG作品之一。',
    tags: ['纯爱', '全语音', '多线结局', '精美CG'],
    releaseDate: '2025-06-01',
    platform: ['PC', 'Android', 'iOS'],
    developer: '樱花社',
  },
  {
    slug: 'phantom-blade',
    title: '幻影之刃',
    category: 'act',
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20game%20cover%20featuring%20a%20female%20ninja%20warrior%20in%20mid-combat%20pose%20with%20glowing%20phantom%20blades%2C%20dark%20cyberpunk%20city%20background%20with%20neon%20lights%2C%20rain%20effects%2C%20dramatic%20lighting%20with%20purple%20and%20cyan%20highlights&width=800&height=400&seq=game-phantom&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20game%20cover%20featuring%20a%20female%20ninja%20warrior%20in%20combat%20pose%20with%20glowing%20phantom%20blades&width=120&height=80&seq=game-phantom-thumb&orientation=landscape',
    description: '一款高速动作游戏，以流畅的战斗系统与华丽的连击特效著称。玩家将扮演一名拥有幻影之力的忍者，在赛博朋克风格的都市中执行各种任务。游戏拥有超过50种技能组合，深度的角色养成系统以及挑战性十足的Boss战。出色的打击感与视觉表现力，让每一场战斗都令人热血沸腾。',
    tags: ['高速战斗', '连击系统', '赛博朋克', '角色养成'],
    releaseDate: '2025-04-10',
    platform: ['PC'],
    developer: '幻影游戏',
  },
  {
    slug: 'tavern-tycoon',
    title: '酒馆大亨',
    category: 'simulation',
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Charming%20simulation%20game%20cover%20depicting%20a%20warm%20cozy%20fantasy%20tavern%20interior%20with%20wooden%20furnishings%2C%20glowing%20lanterns%2C%20various%20adventurer%20characters%20enjoying%20drinks%20at%20the%20bar%2C%20warm%20firelight%20ambiance%2C%20rich%20brown%20and%20gold%20tones&width=800&height=400&seq=game-tavern&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Charming%20simulation%20game%20cover%20depicting%20a%20warm%20cozy%20fantasy%20tavern%20interior%20with%20wooden%20furnishings%2C%20glowing%20lanterns&width=120&height=80&seq=game-tavern-thumb&orientation=landscape',
    description: '一款轻松愉快的模拟经营游戏，玩家将经营一家奇幻世界中的酒馆。从菜单设计、员工管理到装修布置，每一个细节都由你掌控。游戏中的每位顾客都有独特的故事背景与喜好，与他们互动可以解锁特殊剧情与奖励。温馨治愈的氛围、丰富多彩的经营玩法以及迷人的像素美术风格，让人流连忘返。',
    tags: ['经营模拟', '角色互动', '像素美术', '轻松治愈'],
    releaseDate: '2025-02-28',
    platform: ['PC', 'Switch', 'Android'],
    developer: '温馨工坊',
  },
  {
    slug: 'echoes-of-the-abyss',
    title: '深渊回响',
    category: 'indie',
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20indie%20game%20cover%20with%20a%20lone%20figure%20descending%20into%20a%20dark%20glowing%20abyss%2C%20surreal%20geometric%20patterns%20and%20ancient%20runes%20floating%20in%20the%20void%2C%20deep%20blue%20and%20teal%20color%20palette%20with%20ethereal%20light%20rays&width=800&height=400&seq=game-abyss&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20indie%20game%20cover%20with%20a%20lone%20figure%20descending%20into%20a%20dark%20glowing%20abyss%2C%20surreal%20geometric%20patterns&width=120&height=80&seq=game-abyss-thumb&orientation=landscape',
    description: '一款获奖无数的独立游戏佳作，以独特的美术风格与深刻的哲学主题打动了全球玩家。玩家将深入一个神秘的地下世界，通过解谜与探索逐步揭开关于记忆、存在与自我的深刻命题。手绘水彩风格的美术、沉浸式的音乐氛围以及发人深省的叙事方式，让这部作品成为独立游戏界的一颗明珠。',
    tags: ['独立佳作', '解谜探索', '手绘美术', '哲学主题'],
    releaseDate: '2025-05-05',
    platform: ['PC', 'Switch'],
    developer: '回声工作室',
  },
  {
    slug: 'dragon-awakening',
    title: '龙之觉醒',
    category: 'rpg',
    rating: 9.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20RPG%20cover%20art%20featuring%20a%20majestic%20dragon%20awakening%20from%20crystal%20slumber%20in%20an%20ancient%20temple%2C%20a%20heroine%20standing%20before%20it%20with%20sword%20raised%2C%20stained%20glass%20windows%20casting%20colorful%20light%20rays%2C%20dramatic%20composition&width=800&height=400&seq=game-dragon&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20RPG%20cover%20art%20featuring%20a%20majestic%20dragon%20awakening%20from%20crystal%20slumber%20in%20an%20ancient%20temple&width=120&height=80&seq=game-dragon-thumb&orientation=landscape',
    description: '一款以龙族复苏为主题的大型RPG作品。古老的预言正在应验，沉睡千年的龙族即将觉醒，世界面临着前所未有的危机。玩家将召集各具特色的伙伴，穿越广袤的大陆，探索古代遗迹，揭开龙族复苏背后的真相。宏大的世界观、丰富的支线任务以及极具挑战性的战斗系统，为玩家带来一场难忘的冒险之旅。',
    tags: ['龙族主题', '伙伴系统', '宏大世界', '挑战战斗'],
    releaseDate: '2025-07-18',
    platform: ['PC'],
    developer: '龙焰工作室',
  },
  {
    slug: 'neon-dystopia',
    title: '霓虹反乌托邦',
    category: 'avg',
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cyberpunk%20visual%20novel%20cover%20with%20a%20neon-lit%20dystopian%20cityscape%20at%20night%2C%20holographic%20advertisements%20reflecting%20on%20wet%20streets%2C%20a%20mysterious%20female%20protagonist%20in%20futuristic%20attire%20on%20a%20rooftop%2C%20purple%20and%20pink%20neon%20glow&width=800&height=400&seq=game-neon&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Cyberpunk%20visual%20novel%20cover%20with%20a%20neon-lit%20dystopian%20cityscape%20at%20night%2C%20holographic%20advertisements&width=120&height=80&seq=game-neon-thumb&orientation=landscape',
    description: '一款设定在近未来反乌托邦世界的视觉小说。在这个被巨型企业统治的城市中，玩家将扮演一名黑客，揭开隐藏在霓虹灯光背后的黑暗真相。游戏采用赛博朋克美学风格，配合电子音乐与沉浸式音效，营造出独特的未来都市氛围。多重选择分支与蝴蝶效应系统，让玩家的每一个决定都将深远影响故事走向。',
    tags: ['赛博朋克', '黑客题材', '分支选择', '电子音乐'],
    releaseDate: '2025-08-01',
    platform: ['PC', 'Android'],
    developer: '霓虹社',
  },
];

export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string[];
  category: string;
  author: string;
  date: string;
  imageUrl: string;
  tags: string[];
  readTime: string;
}

export const articles: Article[] = [
  {
    slug: 'top-rpg-games-2025',
    title: '2025年最值得玩的十大RPG黄油游戏推荐',
    excerpt: '为你精心挑选了2025年最值得体验的十款RPG黄油游戏，从剧情深度到战斗系统，全方位评测帮你找到最适合你的那一款。',
    content: [
      '在黄油游戏的世界里，RPG类型一直是最受玩家欢迎的品类之一。2025年更是涌现了大量优秀的RPG作品，无论是剧情深度、游戏性还是美术品质都达到了新的高度。本文将为大家盘点2025年最值得玩的十大RPG黄油游戏。',
      '榜首毫无疑问是《星海幻境》，这款融合了太空歌剧与古典奇幻的作品，凭借其超过100小时的丰富剧情与多线结局系统，成为了年度现象级作品。游戏中的角色塑造极为出色，每个角色都有着完整的故事弧光和成长轨迹。',
      '紧随其后的是《龙之觉醒》，以龙族复苏为主题，构建了一个宏大的奇幻世界。游戏的战斗系统设计精妙，尤其是龙魂附体机制，让战斗充满策略性与变数。支线任务的丰富程度也令人惊叹，很多支线的精彩程度甚至不亚于主线。',
      '第三名是《永恒之塔》，一款以大逃杀为背景的创新RPG。玩家需要在不断缩小的安全区域内，通过探索、战斗与策略来生存到最后。游戏将Roguelike元素与RPG养成系统完美结合，每次游玩都有全新的体验。',
      '在选择RPG黄油游戏时，建议玩家根据自己的偏好来选择：如果你喜欢沉浸式剧情，可以选择《星海幻境》或《龙之觉醒》；如果你更注重战斗体验，《幻影之刃》和《永恒之塔》会是不错的选择。无论选择哪一款，2025年的RPG黄油游戏阵容都不会让你失望。',
    ],
    category: 'rpg',
    author: '游戏猎人',
    date: '2025-07-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Top%20RPG%20games%20collage%20style%20banner%20featuring%20fantasy%20characters%2C%20dragons%2C%20and%20magical%20landscapes%20in%20an%20epic%20composition%2C%20warm%20golden%20lighting%20with%20dramatic%20shadows%2C%20game%20magazine%20cover%20style%2C%20editorial%20illustration&width=800&height=400&seq=article-rpg-2025&orientation=landscape',
    tags: ['RPG推荐', '游戏评测', '2025年度', '热门游戏'],
    readTime: '8分钟',
  },
  {
    slug: 'avg-game-guide',
    title: '黄油AVG游戏入坑指南：从零开始的视觉小说之旅',
    excerpt: '第一次接触黄油AVG游戏不知道从何下手？这篇入坑指南将带你从零开始，了解AVG游戏的各种类型、推荐作品以及游玩技巧。',
    content: [
      'AVG（Adventure Game），也就是我们常说的视觉小说类游戏，是黄油游戏中不可忽视的重要品类。它以文字叙事为核心，配合精美的立绘、背景和音乐，为玩家带来沉浸式的故事体验。对于刚刚接触这个类型的新手玩家来说，可能会有些迷茫——游戏太多，该从哪一款开始呢？',
      '如果你是纯爱题材的爱好者，那么《樱花回忆》绝对是你的首选。这款作品以细腻的笔触描绘了一段跨越时空的樱花之恋，全语音配音与精美CG的结合，让整个故事充满了感染力与代入感。游戏的多线结局设计也让每位玩家都能找到属于自己的完美结局。',
      '对于喜欢科幻题材的玩家，《霓虹反乌托邦》会是一个惊喜。这款赛博朋克风格的AVG以其独特的世界观和引人入胜的剧情，在玩家群体中获得了极高的评价。游戏中设置的蝴蝶效应系统，让你的每一个选择都会对故事产生深远影响，大大增强了游戏的代入感和重玩价值。',
      '新手玩家在选择AVG游戏时，建议先从全年龄向或轻度作品入手，逐步了解这个类型的叙事节奏与互动方式。同时，善用游戏的存档功能，在关键选择节点保存进度，这样可以在不剧透的情况下体验到不同选择的乐趣。最后，不要急于通关——AVG游戏的魅力在于慢慢品味故事的过程。',
    ],
    category: 'avg',
    author: '视觉小说控',
    date: '2025-06-20',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20visual%20novel%20game%20screens%20on%20a%20monitor%2C%20cherry%20blossom%20petals%20scattered%20on%20a%20wooden%20desk%2C%20warm%20ambient%20lighting%20from%20a%20desk%20lamp%2C%20tea%20cup%20nearby%2C%20soft%20pink%20and%20cream%20color%20palette&width=800&height=400&seq=article-avg-guide&orientation=landscape',
    tags: ['AVG入门', '新手攻略', '视觉小说', '游戏推荐'],
    readTime: '10分钟',
  },
  {
    slug: 'indie-games-spotlight',
    title: '不可错过的独立黄油游戏精选：小而美的创意佳作',
    excerpt: '独立游戏是黄油游戏界的一股清流，它们以独特的创意和精致的制作征服了无数玩家。本期为你精选五款不可错过的独立黄油游戏作品。',
    content: [
      '在黄油游戏的广阔世界中，独立游戏以其独特的魅力和创新精神占据着特殊的位置。不同于大制作的商业作品，独立游戏往往在有限的预算下，通过独树一帜的美术风格、新颖的玩法设计或者深刻的主题表达来吸引玩家。',
      '首推的当然是《深渊回响》，这款手绘水彩风格的独立游戏以其深刻的哲学主题和精美的视觉呈现，获得了多项独立游戏大奖。游戏将解谜与叙事巧妙融合，玩家在探索神秘地下世界的过程中，会逐渐触及关于记忆、存在与自我的深刻思考。这不仅仅是一款游戏，更是一次心灵的旅程。',
      '同样值得关注的还有《时光旅人》，一款以时间循环为核心机制的独立作品。玩家需要在不断重复的同一天中，通过细微的改变来影响事件的走向。游戏的叙事设计极为精巧，每一次循环都会揭示新的线索，最终拼凑出一个感人至深的完整故事。',
      '独立游戏虽然预算有限，但创意无限。在挑选独立黄油游戏时，建议关注其在玩法机制或叙事方式上的创新之处——往往这些地方蕴藏着最大的惊喜。同时，很多独立游戏的作者会在社区中积极与玩家互动，这也是独立游戏独有的魅力所在。',
    ],
    category: 'indie',
    author: '独立游戏挖掘机',
    date: '2025-05-10',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20indie%20game%20showcase%20with%20various%20hand-drawn%20game%20elements%20floating%20in%20a%20creative%20studio%20space%2C%20watercolor%20textures%2C%20paint%20brushes%20on%20a%20wooden%20desk%2C%20soft%20natural%20window%20light&width=800&height=400&seq=article-indie&orientation=landscape',
    tags: ['独立游戏', '创意佳作', '小众推荐', '游戏评测'],
    readTime: '7分钟',
  },
  {
    slug: 'slg-strategy-tips',
    title: '黄油SLG游戏进阶攻略：从萌新到大神的策略之路',
    excerpt: '想要在SLG黄油游戏中脱颖而出？这篇进阶攻略将分享从资源管理到战斗布阵的实用技巧，助你快速成长为策略大师。',
    content: [
      'SLG（Simulation Game）策略模拟游戏考验的是玩家的规划能力与大局观。在黄油SLG游戏中，除了常规的策略玩法外，角色互动与剧情推进也是重要的游戏元素。这篇攻略将为各位玩家提供从入门到精通的实用建议。',
      '资源管理是SLG游戏的基础。以《王国征途》为例，游戏初期最关键的是平衡金币、粮食与人口三项核心资源。建议优先建设经济类建筑，确保资源产出稳定后，再逐步扩张军事力量。常见的错误是过早扩张导致资源链断裂，这在后期会带来灾难性的后果。',
      '战斗布阵方面，了解兵种克制关系是取胜的关键。步兵克制弓兵、弓兵克制骑兵、骑兵克制步兵的三角克制关系在大多数SLG游戏中都适用。在此基础上，合理利用地形加成和英雄技能，可以大幅提升战斗效率。建议在每场重要战斗前，先观察敌方阵容并针对性地调整自己的出战配置。',
      '角色互动也是黄油SLG的重要组成部分。与游戏中的角色建立良好关系，不仅可以解锁专属剧情和CG，还能获得战斗加成与特殊资源。建议根据角色的性格特点选择不同的互动策略，真诚的互动往往比功利性的刷好感度更有效。',
    ],
    category: 'slg',
    author: '策略大师',
    date: '2025-04-25',
    imageUrl: 'https://readdy.ai/api/search-image?query=Strategic%20war%20room%20scene%20with%20a%20large%20map%20table%20covered%20in%20miniatures%20and%20markers%2C%20medieval%20fantasy%20setting%2C%20candlelit%20atmosphere%2C%20detailed%20strategy%20planning%20elements%2C%20warm%20dark%20wood%20tones&width=800&height=400&seq=article-slg-tips&orientation=landscape',
    tags: ['SLG攻略', '策略技巧', '进阶指南', '资源管理'],
    readTime: '12分钟',
  },
  {
    slug: 'act-combat-system',
    title: '黄油ACT游戏战斗系统深度解析：操作与策略的完美平衡',
    excerpt: '深入分析当前热门黄油ACT游戏的战斗系统设计，从连招机制到Boss战策略，为你揭开动作游戏的核心魅力。',
    content: [
      'ACT（Action）动作游戏以爽快的操作手感和视觉冲击力著称。在黄油ACT游戏中，战斗系统的设计往往决定了游戏的整体品质。本文将从多个维度对当前热门黄油ACT游戏的战斗系统进行深度解析。',
      '《幻影之刃》的战斗系统是其最大的亮点。游戏采用了高速连击+技能取消的机制，玩家可以通过精准的时机把控，在连招过程中取消后摇并衔接新的技能，形成华丽的无限连招。这套系统的学习曲线设计合理，新手可以轻松上手基础连招，而高手则能通过钻研创造出令人眼花缭乱的combo。',
      'Boss战设计方面，好的Boss战应该是一场舞蹈而非单纯的数值碾压。《幻影之刃》中的Boss拥有多阶段形态变化，每个阶段都会引入新的攻击模式，要求玩家不断适应和调整策略。Boss的每招都有明显的攻击前摇，鼓励玩家通过观察来预判和闪避——这正是动作游戏"易学难精"的精髓所在。',
      '对于想要提升ACT游戏水平的玩家，建议从练习基础操作开始：熟练掌握闪避时机、学会读取敌人攻击模式、合理管理技能冷却。不要急于追求华丽的连招——扎实的基本功才是成为动作游戏高手的基础。',
    ],
    category: 'act',
    author: '动作游戏发烧友',
    date: '2025-03-30',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20game%20combat%20scene%20with%20motion%20blur%20effects%2C%20a%20ninja%20character%20executing%20a%20powerful%20strike%20with%20energy%20trails%2C%20dark%20atmospheric%20arena%20with%20dramatic%20spot%20lighting%2C%20particles%20and%20slash%20effects&width=800&height=400&seq=article-act-combat&orientation=landscape',
    tags: ['ACT战斗', '系统解析', 'Boss攻略', '操作技巧'],
    readTime: '9分钟',
  },
  {
    slug: 'simulation-games-guide',
    title: '模拟经营黄油游戏推荐：在虚拟世界中打造你的理想生活',
    excerpt: '模拟经营类黄油游戏让你在虚拟世界中体验创造与管理的乐趣。本文为你推荐多款不同类型的热门模拟经营作品。',
    content: [
      '模拟经营类游戏是黄油游戏中一个温暖而治愈的角落。在这里，没有紧张的生死搏杀，没有沉重的命运抉择，只有创造与管理带来的纯粹快乐。无论是经营一家酒馆、管理一座农场还是建设一座城市，模拟经营游戏都能让你在虚拟世界中找到属于自己的节奏。',
      '《酒馆大亨》是近期最受欢迎的模拟经营黄油游戏之一。游戏中，你将经营一家奇幻世界中的酒馆。从菜单设计到员工管理，从装修布置到顾客互动，每一个细节都在你的掌控之中。游戏的像素美术风格温馨可爱，角色互动系统丰富有趣，是一款让人玩了就停不下来的佳作。',
      '如果你对农业经营感兴趣，那么《丰收物语》值得一试。这款以乡村农业为主题的模拟游戏，让玩家在四季更替中体验播种、收获的喜悦。游戏的真实农耕系统与温馨的人际互动完美融合，营造出一种远离城市喧嚣的田园诗意。',
      '模拟经营类游戏的核心魅力在于"从无到有"的创造过程。看着自己一手打造的酒馆日渐红火、农场硕果累累，那种成就感是其他类型游戏难以比拟的。建议新手从节奏较慢的作品入手，慢慢感受这类游戏的独特魅力。',
    ],
    category: 'simulation',
    author: '经营达人',
    date: '2025-02-15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Charming%20cozy%20game%20scene%20with%20a%20pixel%20art%20fantasy%20tavern%20bustling%20with%20activity%2C%20warm%20fireplace%20glow%2C%20various%20character%20interactions%20at%20wooden%20tables%2C%20shelves%20filled%20with%20potion%20bottles%2C%20golden%20amber%20tones&width=800&height=400&seq=article-sim-guide&orientation=landscape',
    tags: ['模拟经营', '游戏推荐', '休闲游戏', '像素美术'],
    readTime: '8分钟',
  },
];

export const categoryPageData: Record<string, { title: string; description: string; keywords: string[]; faq: { question: string; answer: string }[] }> = {
  rpg: {
    title: 'RPG角色扮演黄油游戏',
    description: '汇聚最全的RPG角色扮演类黄油游戏资源，涵盖经典与最新作品，提供详细评测与下载指引，帮助玩家找到最好玩的RPG黄油游戏。',
    keywords: ['RPG黄油游戏', '角色扮演黄油', 'RPG游戏推荐', '黄油RPG下载'],
    faq: [
      { question: '什么是RPG黄油游戏？', answer: 'RPG黄油游戏是以角色扮演为核心玩法的黄油游戏类型，玩家通过控制角色在奇幻或科幻世界中探索、战斗、成长，同时体验丰富的剧情与角色互动。' },
      { question: '2025年有哪些好玩的RPG黄油游戏？', answer: '2025年热门RPG黄油游戏包括《星海幻境》、《龙之觉醒》等，这些作品在剧情深度、战斗系统和美术品质上都达到了很高的水准。' },
    ],
  },
  slg: {
    title: 'SLG策略模拟黄油游戏',
    description: '汇聚最全的SLG策略模拟类黄油游戏资源，包含城市建设、领土争夺、资源管理等类型，提供详细攻略与评测。',
    keywords: ['SLG黄油游戏', '策略模拟黄油', 'SLG游戏推荐', '黄油策略下载'],
    faq: [
      { question: 'SLG黄油游戏适合新手吗？', answer: '大多数SLG黄油游戏都设计了完善的新手引导系统，建议从节奏较慢的作品入手，逐步熟悉资源管理和策略规划的核心玩法。' },
      { question: 'SLG和RPG黄油游戏有什么区别？', answer: 'SLG更侧重策略规划与资源管理，而RPG更侧重角色成长与剧情体验。两者各有特色，玩家可以根据自己的偏好选择。' },
    ],
  },
  avg: {
    title: 'AVG文字冒险黄油游戏',
    description: '汇聚最全的AVG文字冒险类黄油游戏资源，包含纯爱、科幻、悬疑等多种题材，提供详细评测与下载指引。',
    keywords: ['AVG黄油游戏', '文字冒险黄油', '视觉小说推荐', '黄油AVG下载'],
    faq: [
      { question: 'AVG黄油游戏需要操作技巧吗？', answer: 'AVG黄油游戏以文字阅读和选择分支为核心，几乎不需要操作技巧。玩家主要体验的是故事剧情与角色互动。' },
      { question: '推荐新手玩的AVG黄油游戏有哪些？', answer: '新手推荐从《樱花回忆》开始，这款游戏剧情温馨感人，操作简单，全语音配音让阅读体验更加沉浸。' },
    ],
  },
  act: {
    title: 'ACT动作黄油游戏',
    description: '汇聚最全的ACT动作类黄油游戏资源，包含高速战斗、连击系统、Boss挑战等元素，提供详细攻略与评测。',
    keywords: ['ACT黄油游戏', '动作黄油', 'ACT游戏推荐', '黄油动作下载'],
    faq: [
      { question: 'ACT黄油游戏对手速要求高吗？', answer: '不同的ACT游戏难度各异。入门级作品对手速要求不高，更注重策略选择；硬核作品则需要一定的操作基础。建议从难度较低的作品开始。' },
    ],
  },
  simulation: {
    title: '模拟经营黄油游戏',
    description: '汇聚最全的模拟经营类黄油游戏资源，包含酒馆经营、农场管理、城市建造等类型，提供详细攻略与推荐。',
    keywords: ['模拟经营黄油', '经营游戏推荐', '模拟黄油下载', '休闲经营黄油'],
    faq: [
      { question: '模拟经营黄油游戏需要氪金吗？', answer: '大部分优秀的模拟经营黄油游戏采用买断制，购买后即可畅玩全部内容，无需额外氪金。少数免费游戏提供内购加速选项，但不影响核心体验。' },
    ],
  },
  indie: {
    title: '独立黄油游戏',
    description: '汇聚最全的独立黄油游戏资源，包含创意独特的独立作品，独特的美术风格与创新的玩法设计，提供详细评测与推荐。',
    keywords: ['独立黄油游戏', '创意黄油', '独立游戏推荐', '小众黄油下载'],
    faq: [
      { question: '独立黄油游戏的品质有保障吗？', answer: '虽然独立游戏预算有限，但很多独立作品在美术风格、玩法创新和叙事深度上不输商业大作。建议关注获得过独立游戏奖项的作品。' },
      { question: '如何发现优秀的独立黄油游戏？', answer: '可以通过黄油游戏大全的分类浏览、社区推荐以及各大游戏平台的独立游戏专区来发现优秀的独立作品。' },
    ],
  },
};